import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direciton: row;
  height: 100%;
  justify-content: center;
`;

export const Text = styled(TextLayoutComponent.Bold)`
  text-align: center;
`;

export const TextContainer = styled.div`
  display: block;
`;

export const Link = styled.a``;
